module.exports = __webpack_public_path__ + "media/home_banner.6b58408c.mp4";